import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getUserAgents } from '../lib/database';
import { getLastUsedAgent } from '../lib/lastUsedAgent';

const AgentRedirect: React.FC = () => {
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const findAgentToRedirectTo = async () => {
      console.log("AgentRedirect: useEffect triggered. Finding agent to redirect to...");
      try {
        const agents = await getUserAgents();
        console.log("AgentRedirect: getUserAgents returned:", agents);
        
        if (agents.length === 0) {
          console.log("AgentRedirect: No agents found. Redirecting to /create");
          setRedirectPath('/create');
          return;
        }

        const lastUsedId = getLastUsedAgent();
        console.log(`AgentRedirect: Last used agent ID from localStorage: ${lastUsedId}`);
        
        if (lastUsedId) {
          const lastUsedAgent = agents.find(agent => agent.id === lastUsedId);
          if (lastUsedAgent) {
            console.log(`AgentRedirect: Found last used agent (${lastUsedId}). Redirecting to /agent/${lastUsedId}`);
            setRedirectPath(`/agent/${lastUsedId}`);
            return;
          }
          console.log("AgentRedirect: Last used agent not in the fetched list. Proceeding to fallback.");
        }

        console.log(`AgentRedirect: Fallback. Redirecting to first agent in list: ${agents[0].id}`);
        setRedirectPath(`/agent/${agents[0].id}`);
      } catch (error) {
        console.error('AgentRedirect: Error finding agent to redirect to:', error);
        console.log("AgentRedirect: Error occurred. Redirecting to /create as a failsafe.");
        setRedirectPath('/create');
      } finally {
        console.log("AgentRedirect: Finished finding agent. Setting isLoading to false.");
        setIsLoading(false);
      }
    };

    findAgentToRedirectTo();
  }, []);

  if (isLoading) {
    console.log("AgentRedirect: Render - isLoading is true. Showing loading spinner.");
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-netlify-teal border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (redirectPath) {
    console.log(`AgentRedirect: Render - redirectPath is set to '${redirectPath}'. Navigating...`);
    return <Navigate to={redirectPath} replace />;
  }

  console.log("AgentRedirect: Render - isLoading is false, but no redirectPath. Returning null.");
  return null;
};

export default AgentRedirect;